<template>
    <div v-if="config.display && !localLoading" :style="{'width': config.width || '100%'}" :class="{'control': true, 'disable-fields': config.disableFields}"  v-bind="config" :data-test-id="dataTestId">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <pdf v-bind="passedProps" c-id="pdf" :prop-template-hash="value" @update:prop-template-hash="value = $event"></pdf>
        </div>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};

export const pdfControl = {
    editorSettings: editorSettings,
    data: function () {
        return {
            localLoading: false
        };
    },
    mixins: [controlMixins],
    computed: {
        passedProps() {
            let passedProps = {};
            for (let propName in this.config) {
                if (propName === 'length') continue;
                passedProps['prop-' + propName] = this.config[propName];
                passedProps[propName] = this.config[propName];
            }
            return passedProps;
        }
    },
};

export default pdfControl;
</script>
